import { defineStore } from "pinia";
import router from "../routes/core";
import { useMutation, useQuery } from "@vue/apollo-composable";
import { submitContactForm, submitNewsletterForm } from "@/graphql/core";
import { createRegistrationToFreeMeeting, 
    createRegistrationToFreeEvent, 
    createCoachingRegistration, 
    createRegistrations, 
    confirmRegistration, 
    sendConfidentialityApproval, 
    createGraduationRegistration, 
    createGraduationExtraSeatsRegistration,
    confirmPartnerApproval,
    confirmApproval,
    registrationsByEmailAndCode } from "@/graphql/registrations";

import { useCore } from '@/stores/core'
import { useAuth } from '@/stores/auth'

export const useRegistrations = defineStore('registrations', {    
    state: () => {
        return {
            data: {
                address: null,
                birth_day: "Jour",
                birth_month: "Mois",
                birth_year: "Année",
                city: null,
                // code: "GRADCRAM2025",
                code: "",
                country: null,
                email: "",
                gender: null,
                salutations: "",
                firstname: "",
                lastname: "",
                number_of_persons: 1,
                extra_seats: false,
                number_of_extra_seats: 0,
                postal_code: null,
                state: null,
                telephone: "",

                // ANDC help
                availability: '',
                meet_remotely: null,
                nearest_subway_station: null,
                registration_type: null,
                objectives: null,
                therapist_gender: null,
                therapist_name: null,
                transport: null,
                type: "",
                when_to_call: null,
                availability_day: new Date().getDate().toString().padStart(2, '0'),
                availability_month: (new Date().getMonth() + 1).toString().padStart(2, '0'),
                availability_year: new Date().getFullYear().toString(),
                health_status: null,
                reference: null,

                with_partner: null,
                partner_firstname: '',
                partner_lastname: '',
                partner_address: '',
                partner_postal_code: '',
                partner_telephone: '',
                partner_email: '',
                partner_city: '',
                partner_birth_day: 'Jour',
                partner_birth_month: 'Mois',
                partner_birth_year: 'Année',

                child_firstname: '',
                child_lastname: '',
                child_birth_day: 'Jour',
                child_birth_month: 'Mois',
                child_birth_year: 'Année',

                // Coaching
                company: '',
                department: '',
                position: '',

                // Contact
                message: '',
                how_to_contact: [],

                is_completed: false,
                is_consented: false,
                is_absolutely_consented: false,
                wants_newsletter: false,
            },

            errors: {
                address: null,
                birth_day: null,
                birth_month: null,
                birth_year: null,
                city: null,
                code: null,
                invalid_code: false,
                number_of_persons: null,
                email: null,
                salutations: null,
                firstname: null,
                lastname: null,
                postal_code: null,
                telephone: null,

                // ANDC help
                availability: false,
                meet_remotely: null,
                registration_type: null,
                objectives: null,
                therapist_gender: null,
                transport: null,
                type: null,
                when_to_call: null,
                with_partner: null,
                partner_firstname: null,
                partner_lastname: null,
                child_firstname: null,
                child_lastname: null,
                availability_day: null,
                availability_month: null,
                availability_year: null,
                health_status: null,
                partner_email: null,
                partner_birth_day: null,
                partner_birth_month: null,
                partner_birth_year: null,
                child_birth_day: null,
                child_birth_month: null,
                child_birth_year: null,

                // Coaching
                company: false,
                department: false,
                position: false,

                show_error_alert: false,
                show_registrations_alert: false,
                account_already_exists: false,
                invalid_session_token: false,
                andc_student_blocked_until_year: false,
                number_of_extra_seats: null,
                graduation_lookup: null,
            },

            andcHelpSteps: {
                num: 1,
                step1: true,
                step2: false,
                step3: false,
                step4: false,
                step5: false,
            },

            trainingBasisRegistrationSteps: {
                num: 1,
                step1: true,
                step2: false,
                step3: false
            },

            referenceOptions: [
                {value: "S/O", label: "Faire un choix"},
                {value: "Baladodiffusion", label: "Baladodiffusion"},
                {value: "Bouche à oreille", label: "Bouche à oreille"},
                {value: "Conférence ou atelier", label: "Conférence ou atelier"},
                {value: "Congrès ou colloque", label: "Congrès ou colloque"},
                {value: "Internet", label: "Internet"},
                {value: "Livres", label: "Livres"},
                {value: "Médias imprimés", label: "Médias imprimés"},
                {value: "Réseaux sociaux", label: "Réseaux sociaux"},
                {value: "Aucun / autre", label: "Aucun / autre"},
            ],

            regionOptions: [
                {value: "north_america", label: "Amérique du Nord"},
                {value: "europe", label: "Europe"},
            ],

            salutationsOptions: [
                {value: "Mme", label: "Mme"},
                {value: "M.", label: "M."},
                {value: "Autre", label: "Autre"},
            ],

            birth_day_options: [
                {value: "Jour", label: "Jour"},
                {value: "01", label: "01"},
                {value: "02", label: "02"},
                {value: "03", label: "03"},
                {value: "04", label: "04"},
                {value: "05", label: "05"},
                {value: "06", label: "06"},
                {value: "07", label: "07"},
                {value: "08", label: "08"},
                {value: "09", label: "09"},
                {value: "10", label: "10"},
                {value: "11", label: "11"},
                {value: "12", label: "12"},
                {value: "13", label: "13"},
                {value: "14", label: "14"},
                {value: "15", label: "15"},
                {value: "16", label: "16"},
                {value: "17", label: "17"},
                {value: "18", label: "18"},
                {value: "19", label: "19"},
                {value: "20", label: "20"},
                {value: "21", label: "21"},
                {value: "22", label: "22"},
                {value: "23", label: "23"},
                {value: "24", label: "24"},
                {value: "25", label: "25"},
                {value: "26", label: "26"},
                {value: "27", label: "27"},
                {value: "28", label: "28"},
                {value: "29", label: "29"},
                {value: "30", label: "30"},
                {value: "31", label: "31"},
            ],

            birth_month_options: [
                {value: "Mois", label: "Mois"},
                {value: "01", label: "01"},
                {value: "02", label: "02"},
                {value: "03", label: "03"},
                {value: "04", label: "04"},
                {value: "05", label: "05"},
                {value: "06", label: "06"},
                {value: "07", label: "07"},
                {value: "08", label: "08"},
                {value: "09", label: "09"},
                {value: "10", label: "10"},
                {value: "11", label: "11"},
                {value: "12", label: "12"},
            ],

            birth_year_options: (() => {
                const currentYear = new Date().getFullYear();

                const years = [];
                years.push({value: "Année", label: "Année"});

                for (let year = currentYear; year >= 1940; year--) {
                    years.push({
                        value: year.toString(),
                        label: year.toString()
                    });
                }
                return years;
            })(),

            availability_year_options: (() => {

                const currentYear = new Date().getFullYear();
                const nextYear = currentYear + 1;

                const years = [];
                years.push({value: "Année", label: "Année"});

                // Add current year and next year only
                years.push({
                    value: currentYear.toString(),
                    label: currentYear.toString()
                });
                years.push({
                    value: nextYear.toString(),
                    label: nextYear.toString()
                });

                return years;
            })(),

            approvalSent: false,

            graduation_remaining_places: null,
            graduation_lookup_error: null,
            graduation_lookup_completed: false,
            graduation_lookup_loading: false,
        };
    },

    // Actions
    actions: {
        isRequired(attribute) {
            if (this.errors.show_error_alert)
            {
                if (this.data[attribute] === null) {
                    return 'text-red-500';
                }

                if (this.data[attribute] !== undefined && this.data[attribute].length === 0) {
                    return 'text-red-500';
                }
                
                // Handle date attributes generically
                if (attribute && attribute.endsWith('_date')) {
                    const baseName = attribute.replace('_date', '');
                    const dayKey = `${baseName}_day`;
                    const monthKey = `${baseName}_month`;
                    const yearKey = `${baseName}_year`;
                    
                    if (this.data[dayKey] === null || this.data[monthKey] === null || this.data[yearKey] === null) {
                        return 'text-red-500';
                    }
                }
            }

            return false;
        },

        refreshErrorAlert() {
            const ignored_keys = [
                'show_error_alert',
                'show_registrations_alert',
                'account_already_exists',
                'invalid_session_token',
                'andc_student_blocked_until_year',
                'invalid_code',
                'graduation_lookup',
                'number_of_extra_seats',
            ];

            const has_field_errors = Object.entries(this.errors).some(([key, value]) => {
                return !ignored_keys.includes(key) && Boolean(value);
            });

            if (!has_field_errors) {
                this.errors.show_error_alert = false;
            }
        },

        clearFilledRequiredErrors() {
            Object.entries(this.data).forEach(([key, value]) => {
                if (!this.errors[key]) {
                    return;
                }

                if (key === 'email' || key === 'partner_email') {
                    return;
                }

                if (key.endsWith('_day') || key.endsWith('_month') || key.endsWith('_year')) {
                    if (/^[+-]?\d+(\.\d+)?$/.test(value)) {
                        this.errors[key] = false;
                    }
                    return;
                }

                if (value !== null && value !== undefined && !(typeof value === 'string' && value.length === 0)) {
                    this.errors[key] = false;
                }
            });

            this.refreshErrorAlert();
        },

        gotoCartPayment(formName) {    
            if (formName == 'andcHelp') {
                localStorage.removeItem('cart');                
                let cart = JSON.parse(localStorage.getItem('cart'));

                const core = useCore();

                if (core.region === 'north_america') {
                    var item = {
                        'id': 1,
                        'slug': 'service-andc-aide-quebec',
                        'type': 'events',
                    };
                }

                if (core.region === 'europe') {
                    var item = {
                        'id': 2,
                        'slug': 'service-andc-aide-europe',
                        'type': 'events',
                    };
                }

                if (cart === null) {
                    cart = [item];
                } else {
                    cart.push(item);
                }

                localStorage.setItem('cart', JSON.stringify(cart));
            }

            if (formName == 'graduation') {
                localStorage.removeItem('cart');                
                let cart = JSON.parse(localStorage.getItem('cart'));

                cart = [
                    {
                        'slug': 'graduation-cram',
                        'number_of_persons': parseInt(this.data.number_of_persons),
                    }
                ];
                localStorage.setItem('cart', JSON.stringify(cart));
                // Don't overwrite the cart_slug - keep the unique one from backend
                // localStorage.setItem('cart_slug', 'graduation-cram');

                localStorage.setItem('registration', JSON.stringify(this.data));
            }

            if (formName == 'graduation_extra_seats') {
                localStorage.removeItem('cart');                
                let cart = JSON.parse(localStorage.getItem('cart'));

                cart = [
                    {
                        'slug': 'graduation-cram-extra-seats',
                        'number_of_extra_seats': parseInt(this.data.number_of_extra_seats),
                    }
                ];
                localStorage.setItem('cart', JSON.stringify(cart));
                // Don't overwrite the cart_slug - keep the unique one from backend
                // localStorage.setItem('cart_slug', 'graduation-cram-extra-seats');

                localStorage.setItem('registration', JSON.stringify(this.data));
            }

            window.scrollTo(0, 0);
            router.push('/panier/paiement');
        },

        goToStep(step) {
            this.andcHelpSteps.step1 = false;
            this.andcHelpSteps.step2 = false;
            this.andcHelpSteps.step3 = false;

            window.scrollTo(0, 0);

            if (step == 1) {
                this.andcHelpSteps.num = 1;
                this.andcHelpSteps.step1 = true;
            }

            if (step == 2) {
                this.andcHelpSteps.num = 2;
                this.andcHelpSteps.step2 = true;
            }

            if (step == 3) {
                this.andcHelpSteps.num = 3;
                this.andcHelpSteps.step3 = true;
            }

            if (step == 4) {
                this.andcHelpSteps.num = 4;
                this.andcHelpSteps.step4 = true;
            }

            if (step == 5) {
                this.andcHelpSteps.num = 5;
                this.andcHelpSteps.step5 = true;
            }
        },

        async registerToFreeEvent(date_id) {
            const core = useCore();

            var payloadValidated = true;

            this.errors.firstname = false;
            this.errors.lastname = false;
            this.errors.telephone = false;
            this.errors.email = false;
            
            if (this.data.firstname.length == 0)
            {
                this.errors.firstname = true;
                payloadValidated = false;
            }

            if (this.data.lastname.length == 0)
            {
                this.errors.lastname = true;
                payloadValidated = false;
            }

            if (this.data.telephone.length == 0)
            {
                this.errors.telephone = true;
                payloadValidated = false;
            }

            if (this.data.email.length == 0)
            {
                this.errors.email = true;
                payloadValidated = false;
            }
            
            if (payloadValidated) {
                return new Promise((resolve, reject) => {
                    const { mutate: createRegistrationMutation, onDone, onError } = useMutation (createRegistrationToFreeEvent, () => ({
                        variables: {
                            date_id: date_id,
                            firstname: this.data.firstname,
                            lastname: this.data.lastname,
                            telephone: this.data.telephone,
                            email: this.data.email,
                            reference: this.data.reference,
                            wants_newsletter: this.data.wants_newsletter,
                            region: core.region,
                        },
                    }));
    
                    const mutation = createRegistrationMutation();
    
                    onError(result => {
                        console.log(result);
                    });
    
                    onDone(result => {
                        this.data.is_completed = true;
                    });
                });
            }
        
            return;    
        },

        async registerToFreeMeeting(date_id) {
            const core = useCore();

            var payloadValidated = true;

            this.errors.firstname = false;
            this.errors.lastname = false;
            this.errors.telephone = false;
            this.errors.email = false;
            
            if (this.data.firstname?.length == 0 || this.data.firstname === null)
            {
                this.errors.firstname = true;
                payloadValidated = false;
            }

            if (this.data.lastname?.length == 0 || this.data.lastname === null)
            {
                this.errors.lastname = true;
                payloadValidated = false;
            }

            if (this.data.telephone?.length == 0 || this.data.telephone === null)
            {
                this.errors.telephone = true;
                payloadValidated = false;
            }

            if (this.data.email?.length == 0 || this.data.email === null)
            {
                this.errors.email = true;
                payloadValidated = false;
            }

            if (! payloadValidated) {
                this.errors.show_error_alert = true;
            }
            
            if (payloadValidated) {
                return new Promise((resolve, reject) => {
                    const { mutate: createRegistrationMutation, onDone, onError } = useMutation (createRegistrationToFreeMeeting, () => ({
                        variables: {
                            date_id: date_id,
                            firstname: this.data.firstname,
                            lastname: this.data.lastname,
                            telephone: this.data.telephone,
                            email: this.data.email,
                            state: this.data.state,
                            country: this.data.country,
                            reference: this.data.reference,
                            wants_newsletter: this.data.wants_newsletter,
                            region: core.region,
                        },
                    }));
    
                    const mutation = createRegistrationMutation();
    
                    onError(result => {
                        console.log(result);
                    });
    
                    onDone(result => {
                        this.data.is_completed = true;
                    });
                });
            }
        
            return;    
        },

        async approveConfidentiality(date_id) {
            var payloadValidated = true;

            this.errors.firstname = false;
            this.errors.lastname = false;
            this.errors.telephone = false;
            this.errors.email = false;
            
            if (this.data.firstname.length == 0)
            {
                this.errors.firstname = true;
                payloadValidated = false;
            }

            if (this.data.lastname.length == 0)
            {
                this.errors.lastname = true;
                payloadValidated = false;
            }

            if (this.data.telephone.length == 0)
            {
                this.errors.telephone = true;
                payloadValidated = false;
            }

            if (this.data.email.length == 0)
            {
                this.errors.email = true;
                payloadValidated = false;
            }
            
            if (payloadValidated) {
                return new Promise((resolve, reject) => {
                    const query = useQuery(sendConfidentialityApproval, { 
                        firstname: this.data.firstname,
                        lastname: this.data.lastname,
                        telephone: this.data.telephone,
                        email: this.data.email,
                    });
    
                    query.onError((error) => reject(error));

                    query.onResult((result) => {       
                        this.approvalSent = true;
                        
                        resolve();
                    });
                });
            }  
        },

        setRegistrationBoolean(attribute) {
            this.data[attribute] = !this.data[attribute];
        },
        
        setRegistrationCategory(category) {
            this.data.category = category;
        },

        setRegistrationType(type) {
            this.data.type = type;

            if (type === 'Couple ou dyade') {
                this.data.with_partner = 'yes';
            }

            this.goToStep(2);
        },
        
        async submitCoachingForm() {
            var payloadValidated = true;

            this.errors.firstname = false;
            this.errors.lastname = false;
            this.errors.company = false;
            this.errors.department = false;
            this.errors.position = false;
            this.errors.address = false;
            this.errors.city = false;
            this.errors.postal_code = false;
            this.errors.telephone = false;
            this.errors.email = false;
            this.errors.when_to_call = false;
            this.errors.objectives = false;
            
            if (this.data.when_to_call?.length == 0 || this.data.when_to_call === null)
            {
                this.errors.when_to_call = true;
                payloadValidated = false;
            }

            if (this.data.objectives?.length == 0 || this.data.objectives === null)
            {
                this.errors.objectives = true;
                payloadValidated = false;
            }

            if (this.data.address?.length == 0 || this.data.address === null)
            {
                this.errors.address = true;
                payloadValidated = false;
            }

            if (this.data.city?.length == 0 || this.data.city === null)
            {
                this.errors.city = true;
                payloadValidated = false;
            }

            if (this.data.postal_code?.length == 0 || this.data.postal_code === null)
            {
                this.errors.postal_code = true;
                payloadValidated = false;
            }

            if (this.data.company?.length == 0 || this.data.company === null)
            {
                this.errors.company = true;
                payloadValidated = false;
            }

            if (this.data.department?.length == 0 || this.data.department === null)
            {
                this.errors.department = true;
                payloadValidated = false;
            }

            if (this.data.position?.length == 0 || this.data.position === null)
            {
                this.errors.position = true;
                payloadValidated = false;
            }

            if (this.data.firstname?.length == 0 || this.data.firstname === null)
            {
                this.errors.firstname = true;
                payloadValidated = false;
            }

            if (this.data.lastname?.length == 0 || this.data.lastname === null)
            {
                this.errors.lastname = true;
                payloadValidated = false;
            }

            if (this.data.telephone?.length == 0 || this.data.telephone === null)
            {
                this.errors.telephone = true;
                payloadValidated = false;
            }

            if (this.data.email?.length == 0 || this.data.email === null)
            {
                this.errors.email = true;
                payloadValidated = false;
            }

            if (! payloadValidated) {
                this.errors.show_error_alert = true;
            }
            
            if (payloadValidated) {
                return new Promise((resolve, reject) => {
                    const { mutate: createCoachingRegistrationMutation, onDone, onError } = useMutation (createCoachingRegistration, () => ({
                        variables: {
                            firstname: this.data.firstname,
                            lastname: this.data.lastname,
                            company: this.data.company,
                            department: this.data.department,
                            position: this.data.position,
                            address: this.data.address,
                            city: this.data.city,
                            postal_code: this.data.postal_code,
                            state: this.data.state,
                            country: this.data.country,
                            telephone: this.data.telephone,
                            email: this.data.email,
                            when_to_call: this.data.when_to_call,
                            objectives: this.data.objectives,
                            reference: this.data.reference,
                            wants_newsletter: this.data.wants_newsletter,
                        },
                    }));
    
                    const mutation = createCoachingRegistrationMutation();
    
                    onError(result => {
                        console.log(result);
                    });
    
                    onDone(result => {
                        this.data.is_completed = true;

                        window.scrollTo(0, 0);
                    });
                });
            }
        
            return;    
        },

        async submitContactForm() {
            var payloadValidated = true;

            this.errors.firstname = false;
            this.errors.lastname = false;
            this.errors.email = false;
            this.errors.telephone = false;
            this.errors.how_to_contact = false;
            this.errors.message = false;
            
            if (this.data.how_to_contact?.length == 0 || this.data.how_to_contact === null)
            {
                this.errors.how_to_contact = true;
                payloadValidated = false;
            }

            if (this.data.message?.length == 0 || this.data.message === null )
            {
                this.errors.message = true;
                payloadValidated = false;
            }

            if (this.data.firstname?.length == 0 || this.data.firstname === null)
            {
                this.errors.firstname = true;
                payloadValidated = false;
            }

            if (this.data.lastname?.length == 0 || this.data.lastname === null)
            {
                this.errors.lastname = true;
                payloadValidated = false;
            }

            if (this.data.telephone?.length == 0 || this.data.telephone === null)
            {
                this.errors.telephone = true;
                payloadValidated = false;
            }

            if (this.data.email?.length == 0 || this.data.email === null)
            {
                this.errors.email = true;
                payloadValidated = false;
            }

            if (! payloadValidated) {
                this.errors.show_error_alert = true;
            }
            
            if (payloadValidated) {
                return new Promise((resolve, reject) => {
                    const { mutate: submitContactFormMutation, onDone, onError } = useMutation (submitContactForm, () => ({
                        variables: {
                            firstname: this.data.firstname,
                            lastname: this.data.lastname,
                            state: this.data.state,
                            country: this.data.country,
                            telephone: this.data.telephone,
                            email: this.data.email,
                            how_to_contact: this.data.how_to_contact.join(', ').replace('email', 'courriel').replace('telephone', 'téléphone'),
                            message: this.data.message,
                        },
                    }));
    
                    const mutation = submitContactFormMutation();
    
                    onError(result => {
                        console.log(result);
                    });
    
                    onDone(result => {
                        this.data.is_completed = true;

                        window.scrollTo(0, 0);
                    });
                });
            }
        
            return;    
        },

        async submitNewsletterForm() {
            const core = useCore();
            const email = this.data.email;
            const region = core.region;

            await grecaptcha.execute('6LfzPikbAAAAAIxw7-VVYug0DAfDiA0nVRgBWp1S', { action: 'newsletter' }).then(function(token) {
                window.token = token;
            });

            return new Promise((resolve, reject) => {
                const { mutate: submitNewsletterFormMutation, onDone, onError } = useMutation (submitNewsletterForm, () => ({
                    variables: {
                        token: window.token,
                        email: email,
                        region: region,
                    },
                }));

                const mutation = submitNewsletterFormMutation();

                onError(result => {
                    console.log(result);
                });

                onDone(result => {
                    this.data.is_subscribed = true;
                    resolve();
                });
            });
        },

        validateEmail() {
            if (! /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.data.email)) {
                this.errors.email = true;
            } else {
                this.errors.email = false;
            }
        },

        validatePartnerEmail() {
            // Check if empty
            if (!this.data.partner_email || this.data.partner_email.length === 0) {
                this.errors.partner_email = true;
                return;
            }
            
            // Check if same as main email
            if (this.data.partner_email === this.data.email) {
                this.errors.partner_email = this.data.type === 'Enfant ou adolescent'
                    ? "Le courriel doit être différent de celui du 1er parent"
                    : "Le courriel du conjoint doit être différent";
                return;
            }
            
            // Check email format
            if (!/^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.data.partner_email)) {
                this.errors.partner_email = true;
                return;
            }
            
            this.errors.partner_email = false;
        },

        validateNumber(attribute, value) {            
            if (! /^[+-]?\d+(\.\d+)?$/.test(this.data[attribute])) {
                this.errors[attribute] = true;
            } else {
                this.errors[attribute] = false;
            }
        },

        validateForm(formName) {
            var is_valid = true;
            var not_required = [];

            // Reset error flags
            this.errors.account_already_exists = false;
            this.errors.invalid_session_token = false;
            this.errors.andc_student_blocked_until_year = false;
            this.errors.show_registrations_alert = false;

            const core = useCore();

            if (formName == 'andcHelp')
            {
                not_required = [
                    'code',
                    'number_of_persons',
                    'company',
                    'department',
                    'extra_seats',
                    'gender',
                    'how_to_contact',
                    'is_absolutely_consented',
                    'is_completed',
                    'is_consented',
                    'message',
                    'number_of_extra_seats',
                    'therapist_name', 
                    'nearest_subway_station', 
                    'reference', 
                    'wants_newsletter',
                    'partner_address',
                    'partner_postal_code',
                    'partner_telephone',
                    'partner_city',
                    'partner_birth_day',
                    'partner_birth_month',
                    'partner_birth_year',
                    'position',
                    'country', 
                    'state', 
                ];

                if (core.region === 'europe') {
                    not_required.push(
                        'transport', 
                        'availability', 
                        'therapist_gender', 
                    );
                }
                
                // For types that are NOT Couple ou dyade AND NOT Enfant ou adolescent
                // with_partner should not be validated at all
                if (this.data.type !== 'Couple ou dyade' && this.data.type !== 'Enfant ou adolescent') {
                    not_required.push(
                        'with_partner',
                        'partner_firstname',
                        'partner_lastname',
                        'partner_birth_day',
                        'partner_birth_month',
                        'partner_birth_year',
                        'partner_email',
                        'child_firstname',
                        'child_lastname',
                        'child_birth_day',
                        'child_birth_month',
                        'child_birth_year',
                    );
                }
                
                // For Couple ou dyade, child fields are not required
                // with_partner is automatically set to 'yes' in setRegistrationType()
                if (this.data.type === 'Couple ou dyade') {
                    not_required.push(
                        'child_firstname',
                        'child_lastname',
                        'child_birth_day',
                        'child_birth_month',
                        'child_birth_year',
                    );
                }
                
                // For Enfant ou adolescent, with_partner MUST be answered (yes or no)
                // Then handle partner fields based on the answer
                if (this.data.type === 'Enfant ou adolescent') {
                    if (this.data.with_partner === 'no') {
                        // If no partner, all partner fields are not required
                        not_required.push(
                            'partner_firstname',
                            'partner_lastname',
                            'partner_birth_day',
                            'partner_birth_month',
                            'partner_birth_year',
                            'partner_email',
                        );
                    }
                    // If with_partner is 'yes', partner fields remain required (firstname, lastname, email)
                    // with_partner itself is required and must be filled (yes or no)
                }
            }

            if (formName == 'cart')
            {
                not_required = [
                    'code',
                    'number_of_persons',
                    'availability',
                    'how_to_contact',
                    'salutations',
                    'with_partner',
                    'partner_address',
                    'partner_postal_code',
                    'partner_telephone',
                    'partner_email',
                    'partner_city',
                    'partner_birth_day',
                    'partner_birth_month',
                    'partner_birth_year',
                    'partner_firstname',
                    'partner_lastname',
                    'child_firstname',
                    'child_lastname',
                    'child_birth_day',
                    'child_birth_month',
                    'child_birth_year',
                    'reference', 
                    'wants_newsletter',
                    'company',
                    'department',
                    'message',
                    'meet_remotely',
                    'nearest_subway_station',
                    'objectives',
                    'position',
                    'registration_type',
                    'therapist_gender',
                    'therapist_name',
                    'transport',
                    'type',
                    'country', 
                    'state', 
                    'availability_day',
                    'availability_month',
                    'availability_year',
                    'health_status',
                ];
            }

            if (formName == 'graduation' || formName == 'graduation_extra_seats')
                {
                    not_required = [
                        'address',
                        'city',
                        'postal_code',
                        'country',
                        'gender',
                        'salutations',
                        'state',
                        'birth_day',
                        'birth_month',
                        'birth_year',
                        'when_to_call',
                        'objectives',
                        'availability',
                        'how_to_contact',
                        'with_partner',
                        'partner_address',
                        'partner_postal_code',
                        'partner_telephone',
                        'partner_email',
                        'partner_city',
                        'partner_birth_day',
                        'partner_birth_month',
                        'partner_birth_year',
                        'partner_firstname',
                        'partner_lastname',
                        'child_firstname',
                        'child_lastname',
                        'child_birth_day',
                        'child_birth_month',
                        'child_birth_year',
                        'reference', 
                        'wants_newsletter',
                        'company',
                        'department',
                        'message',
                        'meet_remotely',
                        'nearest_subway_station',
                        'objectives',
                        'position',
                        'registration_type',
                        'therapist_gender',
                        'therapist_name',
                        'transport',
                        'type',
                        'country', 
                        'state', 
                        'availability_day',
                        'availability_month',
                        'availability_year',
                        'health_status',
                    ];
                }

            if (formName == 'graduation_extra_seats') {
                not_required.push(
                    'code',
                    'number_of_persons',
                    'salutations',
                    'type',
                );
            }

            Object.entries(this.data).forEach(([key, value]) => {
                if (! not_required.some(value => value == key)) {
                    if (value === null || (typeof value === 'string' && value.length === 0)) {
                        is_valid = false;
                        this.errors[key] = true;
                    }
                    else {
                        this.errors[key] = false;
                        
                        if (key == 'email') {
                            if (! /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.data.email)) {
                                is_valid = false;
                                this.errors.email = true;                                
                            } else {
                                this.errors.email = false;
                            }
                        }
                        
                        // Handle date-related attributes generically
                        if (key.endsWith('_day') || key.endsWith('_month') || key.endsWith('_year')) {
                            if (! /^[+-]?\d+(\.\d+)?$/.test(this.data[key])) {
                                is_valid = false;
                                this.errors[key] = true;
                            } else {
                                this.errors[key] = false;
                            }
                        }
                    }
                }      
            });

            // Check for any date-related errors
            const dateErrorKeys = Object.keys(this.errors).filter(key => 
                key.endsWith('_day') || key.endsWith('_month') || key.endsWith('_year')
            );
            
            if (dateErrorKeys.some(key => this.errors[key])) {
                is_valid = false;
            }

            if (formName == 'graduation_extra_seats') {
                if (!this.graduation_lookup_completed || this.graduation_lookup_error) {
                    is_valid = false;
                    this.errors.graduation_lookup = true;
                } else {
                    this.errors.graduation_lookup = false;
                }

                const extra_seats = parseInt(this.data.number_of_extra_seats);
                if (!extra_seats || extra_seats < 1 || extra_seats > this.graduation_remaining_places) {
                    is_valid = false;
                    this.errors.number_of_extra_seats = true;
                } else {
                    this.errors.number_of_extra_seats = false;
                }
            }
                 
            if (is_valid === false) {
                this.errors.show_error_alert = true;

                return is_valid;
            } else {
                localStorage.setItem('registration', JSON.stringify(this.data));

                if (formName == 'andcHelp') {
                    localStorage.removeItem('cart');                
                    let cart = JSON.parse(localStorage.getItem('cart'));
    
                    const core = useCore();
    
                    if (core.region === 'north_america') {
                        var item = {
                            'slug': 'service-andc-aide-quebec',
                        };
                    }
    
                    if (core.region === 'europe') {
                        var item = {
                            'slug': 'service-andc-aide-europe',
                        };
                    }
    
                    if (cart === null) {
                        cart = [item];
                    } else {
                        cart.push(item);
                    }
    
                    localStorage.setItem('cart', JSON.stringify(cart));
                }

                if (formName == 'graduation') {
                    if (this.data.number_of_persons == 1) {
                        // May need to setup the cart here when the number of persons is more than 1
                        this.createGraduationRegistration();
                    } else {
                        // For multiple persons, we need to create a registration first
                        this.createGraduationRegistration();
                    }
                } else if (formName == 'graduation_extra_seats') {
                    this.createGraduationExtraSeatsRegistration();
                } else {
                    // Create registrations for each item in the cart
                    this.createRegistrations(formName);
                }
            }
        }, 

        async submitGraduationForm() {
            return new Promise((resolve, reject) => {
                this.validateForm('graduation');
            });
        },

        async submitGraduationExtraSeatsForm() {
            return new Promise((resolve, reject) => {
                this.validateForm('graduation_extra_seats');
            });
        },

        resetGraduationExtraSeatsLookup() {
            this.graduation_remaining_places = null;
            this.graduation_lookup_error = null;
            this.graduation_lookup_completed = false;
            this.graduation_lookup_loading = false;
            this.data.number_of_extra_seats = 0;
            this.errors.graduation_lookup = null;
            this.errors.number_of_extra_seats = null;
        },

        async lookupGraduationRegistrations(email, graduation_code, graduation_num_places) {
            this.graduation_lookup_loading = true;
            this.graduation_lookup_error = null;
            this.graduation_lookup_completed = false;
            this.graduation_remaining_places = null;
            this.errors.graduation_lookup = null;

            const normalized_email = email.trim().toLowerCase();

            return new Promise((resolve, reject) => {
                const query = useQuery(registrationsByEmailAndCode, {
                    email: normalized_email,
                    code: graduation_code,
                });

                query.onError(() => {
                    this.graduation_lookup_loading = false;
                    this.graduation_lookup_completed = true;
                    this.graduation_lookup_error = 'Une erreur est survenue lors de la vérification. Veuillez réessayer.';
                    resolve();
                });

                query.onResult((result) => {
                    this.graduation_lookup_loading = false;
                    this.graduation_lookup_completed = true;

                    const registrations = result.data?.registrationsByEmailAndCode ?? [];

                    if (registrations.length === 0) {
                        this.graduation_lookup_error = 'Aucune réservation de graduation trouvée pour ce courriel.';
                        this.graduation_remaining_places = 0;
                        resolve();
                        return;
                    }

                    const sum = registrations.reduce((total, registration) => {
                        return total
                            + (registration.number_of_persons || 0)
                            + (registration.number_of_extra_seats || 0);
                    }, 0);

                    const remaining = graduation_num_places - sum;
                    this.graduation_remaining_places = remaining;

                    if (remaining <= 0) {
                        this.graduation_lookup_error = 'Vous ne pouvez plus acheter de billets pour la graduation.';
                        resolve();
                        return;
                    }

                    const latest = [...registrations].sort((a, b) => b.id - a.id)[0];
                    this.data.firstname = latest.firstname || '';
                    this.data.lastname = latest.lastname || '';
                    this.data.telephone = latest.telephone || '';
                    this.data.number_of_extra_seats = '';
                    resolve();
                });
            });
        },

        async createGraduationRegistration() {
            return new Promise((resolve, reject) => {
                const core = useCore();

                const { mutate: createGraduationRegistrationMutation, onDone, onError } = useMutation (createGraduationRegistration, () => ({
                    variables: {
                        region: core.region,
                        code: this.data.code,
                        firstname: this.data.firstname,
                        lastname: this.data.lastname,
                        telephone: this.data.telephone,
                        email: this.data.email,
                        number_of_persons: parseInt(this.data.number_of_persons),
                        type: this.data.type,
                        wants_newsletter: this.data.wants_newsletter,
                    },
                }));

                const mutation = createGraduationRegistrationMutation();

                onError(result => {
                    console.log(result);
                    if (result.message.includes('invalidCode')) {
                        this.errors.invalid_code = true;
                    } 
                });

                onDone(result => {                    
                    if (this.data.number_of_persons > 1) {
                        localStorage.setItem('cart_slug', result.data.createGraduationRegistration.cart_slug);
                        this.gotoCartPayment('graduation');
                    } else {
                        window.scrollTo(0, 0);
                        router.push('/panier/confirmation');
                    }
                });
            });
        },

        async createGraduationExtraSeatsRegistration() {
            return new Promise((resolve, reject) => {
                const core = useCore();

                const { mutate: createGraduationExtraSeatsRegistrationMutation, onDone, onError } = useMutation (createGraduationExtraSeatsRegistration, () => ({
                    variables: {
                        firstname: this.data.firstname,
                        lastname: this.data.lastname,
                        telephone: this.data.telephone,
                        email: this.data.email,
                        number_of_extra_seats: parseInt(this.data.number_of_extra_seats),
                        wants_newsletter: this.data.wants_newsletter,
                    },
                }));

                const mutation = createGraduationExtraSeatsRegistrationMutation();

                onError(result => {
                    console.log(result);
                    if (result.message.includes('invalidCode')) {
                        this.errors.invalid_code = true;
                    } 
                });

                onDone(result => {                    
                    // Check if we have a cart_slug (payment required)
                    if (result.data && result.data.createGraduationExtraSeatsRegistration && result.data.createGraduationExtraSeatsRegistration.cart_slug) {
                        // Payment required - store cart_slug and go to payment
                        localStorage.setItem('cart_slug', result.data.createGraduationExtraSeatsRegistration.cart_slug);
                        this.gotoCartPayment('graduation_extra_seats');
                    } else {
                        // No cart_slug - this shouldn't happen for extra seats, but handle gracefully
                        console.error('No cart_slug returned for extra seats registration');
                        window.scrollTo(0, 0);
                        router.push('/panier/confirmation');
                    }
                });
            });
        },

        async createRegistrations(formName) {
            return new Promise((resolve, reject) => {          
                const core = useCore();
                const authStore = useAuth();
                const session_token = authStore.getAuthToken() || null;

                const { mutate: createRegistrationsMutation, onDone, onError } = useMutation (createRegistrations, () => ({
                    variables: {
                        items: JSON.parse(localStorage.getItem('cart')),
                        session_token,

                        salutations: this.data.salutations,
                        gender: this.data.gender,
                        firstname: this.data.firstname,
                        lastname: this.data.lastname,
                        address: this.data.address,
                        city: this.data.city,
                        postal_code: this.data.postal_code,
                        state: this.data.state,
                        country: this.data.country,
                        telephone: this.data.telephone,
                        email: this.data.email,
                        birth_day: this.data.birth_day,
                        birth_month: this.data.birth_month,
                        birth_year: this.data.birth_year,
                        when_to_call: this.data.when_to_call,
                        wants_newsletter: this.data.wants_newsletter,
                        region: core.region,
                        reference: this.data.reference,

                        // ANDC help
                        availability: this.data.availability,
                        meet_remotely: this.data.meet_remotely,
                        nearest_subway_station: this.data.nearest_subway_station,
                        registration_type: this.data.registration_type,
                        objectives: this.data.objectives,
                        health_status: this.data.health_status,
                        availability_day: this.data.availability_day,
                        availability_month: this.data.availability_month,
                        availability_year: this.data.availability_year,
                        therapist_gender: this.data.therapist_gender,
                        therapist_name: this.data.therapist_name,
                        transport: this.data.transport,
                        type: this.data.type,
                        when_to_call: this.data.when_to_call,

                        with_partner: this.data.with_partner,
                        partner_firstname: this.data.partner_firstname,
                        partner_lastname: this.data.partner_lastname,
                        partner_address: this.data.partner_address,
                        partner_postal_code: this.data.partner_postal_code,
                        partner_telephone: this.data.partner_telephone,
                        partner_email: this.data.partner_email,
                        partner_city: this.data.partner_city,
                        partner_birth_day: this.data.partner_birth_day,
                        partner_birth_month: this.data.partner_birth_month,
                        partner_birth_year: this.data.partner_birth_year,
                        child_firstname: this.data.child_firstname,
                        child_lastname: this.data.child_lastname,
                        child_birth_day: this.data.child_birth_day,
                        child_birth_month: this.data.child_birth_month,
                        child_birth_year: this.data.child_birth_year,
                    },
                }));

                const mutation = createRegistrationsMutation();

                onError(result => {
                    console.log(result); // TODO: Send error to backend

                    const msg = result.message || '';
                    const gqlTexts = (result.graphQLErrors || [])
                        .map((e) => [e.message, e.extensions?.code].filter(Boolean).join(' '))
                        .join(' ');
                    const haystack = `${msg} ${gqlTexts}`;

                    if (haystack.includes('accountAlreadyExists')) {
                        if (!authStore.isLoggedIn) {
                            this.errors.account_already_exists = true;
                        }
                    } else if (haystack.includes('invalidSessionToken')) {
                        this.errors.invalid_session_token = true;
                    } else if (haystack.includes('andcStudentBlockedUntilYear')) {
                        this.errors.andc_student_blocked_until_year = true;
                    } else if (!this.applyRequiredFieldsFromGraphqlError(haystack)) {
                        this.errors.show_registrations_alert = true;
                    }
                });

                onDone(result => {                    
                    this.errors.account_already_exists = false;
                    this.errors.invalid_session_token = false;

                    // Check if we have the expected data structure
                    if (result.data && result.data.createRegistrations && result.data.createRegistrations.length > 0) {
                        localStorage.setItem('cart_slug', result.data.createRegistrations[0].cart_slug);
                        
                        if (this.data.type == 'Enfant ou adolescent' || result.data.createRegistrations[0].is_student) {
                            this.confirmRegistration();
                        } else {
                            this.gotoCartPayment(formName);
                        }
                    } else {
                        console.error('Unexpected createRegistrations response structure:', result);
                        this.errors.show_registrations_alert = true;
                    }
                });
            });
        },

        applyRequiredFieldsFromGraphqlError(message) {
            const match = (message || '').match(/requis[^:]*:\s*([a-z0-9_]+(?:\s*,\s*[a-z0-9_]+)*)/i);

            if (!match) {
                return false;
            }

            const fields = match[1]
                .split(',')
                .map((field) => field.trim())
                .filter((field) => field.length > 0 && Object.prototype.hasOwnProperty.call(this.errors, field));

            if (fields.length === 0) {
                return false;
            }

            fields.forEach((field) => {
                this.errors[field] = true;
            });

            this.errors.show_error_alert = true;

            return true;
        },

        isEmptyRegistrationField(value) {
            return value === null
                || value === undefined
                || (typeof value === 'string' && value.trim() === '');
        },

        prefillFromClient(client) {
            if (!client) {
                return;
            }

            const field_map = {
                salutations: 'salutations',
                firstname: 'firstname',
                lastname: 'lastname',
                email: 'email',
                telephone: 'telephone',
                address: 'address',
                city: 'city',
                postal_code: 'postal_code',
                state: 'state',
                country: 'country',
            };

            for (const [client_key, data_key] of Object.entries(field_map)) {
                const incoming = client[client_key];

                if (this.isEmptyRegistrationField(this.data[data_key]) && !this.isEmptyRegistrationField(incoming)) {
                    this.data[data_key] = incoming;
                }
            }
        },

        async prefillFromSession() {
            const authStore = useAuth();

            if (!authStore.isLoggedIn) {
                return;
            }

            try {
                const result = await authStore.fetchClientProfile();

                if (result.success && result.client) {
                    this.prefillFromClient(result.client);
                    authStore.updateUser(result.client);
                    return;
                }
            } catch (error) {
                console.error('Could not fetch client profile for registration prefill:', error);
            }

            this.prefillFromClient(authStore.user);
        },

        async loginAndRetryRegistration(formName, password) {
            const authStore = useAuth();

            this.errors.account_already_exists = false;
            this.errors.invalid_session_token = false;

            try {
                const result = await authStore.login(this.data.email, password);

                if (result.success) {
                    await this.prefillFromSession();
                    this.createRegistrations(formName);
                }
            } catch (error) {
                console.error('Login failed during registration retry:', error);
            }
        },

        async confirmRegistration() {
            return new Promise((resolve, reject) => {
                const { mutate: confirmRegistrationMutation, onDone, onError } = useMutation (confirmRegistration, () => ({
                    variables: {
                        cart_slug: localStorage.getItem('cart_slug'),
                    },
                }));

                const mutation = confirmRegistrationMutation();

                onError(result => {
                    console.log(result); // TODO: Send error to backend
                });

                onDone(result => {
                    window.scrollTo(0, 0);
                    router.push('/panier/confirmation');
                });
            });
        },

        async confirmPartnerApproval(registration_id) {
            return new Promise((resolve, reject) => {
                const { mutate: confirmPartnerApprovalMutation, onDone, onError } = useMutation (confirmPartnerApproval, () => ({
                    variables: {
                        id: parseInt(registration_id),
                    },
                }));

                const mutation = confirmPartnerApprovalMutation();

                onError(result => {
                    console.log(result);
                });

                onDone(result => {
                    window.scrollTo(0, 0);
                    router.push('/consentement-partenaire-services-andc-aide/confirmation');
                });
            });
        },

        async confirmApproval(registration_id, confirmation_path) {
            return new Promise((resolve, reject) => {
                const { mutate: confirmApprovalMutation, onDone, onError } = useMutation(confirmApproval, () => ({
                    variables: {
                        id: parseInt(registration_id),
                    },
                }));

                const mutation = confirmApprovalMutation();

                onError(result => {
                    console.log(result);
                });

                onDone(result => {
                    window.scrollTo(0, 0);
                    router.push(confirmation_path);
                });
            });
        },
    },
});
